import { IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';
import { useHistory } from 'react-router';

import { booleanBodyRender, entityBaseBodyRender, TableColumn } from '@app/components/common/table';
import { User } from '@app/api/models';

export const useColumns = (): TableColumn<User>[] => {

  const history = useHistory();
  return [
    {
      name: 'username',
      label: 'Пользователь',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'last_name',
      label: 'Фамилия',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'first_name',
      label: 'Имя',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'email',
      label: 'Email',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'phone',
      label: 'Телефон',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'group',
      label: 'Группа',
      options: {
        filter: {
          name: 'group_id',
          sourceName: 'user_group', 
          type: 'multi-select',
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(true),
      },
    },
    {
      name: 'role',
      label: 'Роль',
      options: {
        filter: {
          name: 'role_id',
          sourceName: 'user_role',
          type: 'multi-select',
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(true),
      },
    },
    {
      name: 'position',
      label: 'Должность',
      options: {
        filter: false,
        sort: true,
        customBodyRender: entityBaseBodyRender(true),
      },
    },
    {
      name: 'active',
      label: 'Активен',
      options: {
        filter: {
          type: 'boolean',
        },
        sort: true,
        customBodyRender: booleanBodyRender(),
      },
    },
    {
      name: 'last_seen',
      label: 'Активность',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'id',
      label: 'Изм.',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => (
          <IconButton
            onClick={() => history.push('/users/edit',
              { user: rowData })} aria-label="edit"
          >
            <MdEdit />
          </IconButton>
        ),
      },
    },
  ];
};
